import React, { createContext, useState, useCallback } from "react";

export const SpendAnalyticsSessionContext = createContext();

export const SpendAnalyticsSessionProvider = ({ children }) => {
  const [sessionHistory, setSessionHistory] = useState([]);

  const updateSessionHistory = useCallback((newHistory) => {
    setSessionHistory(newHistory);
  }, []);

  const addNewSession = useCallback((newSession) => {
    setSessionHistory((prev) => [newSession, ...prev]);
  }, []);

  const value = {
    sessionHistory,
    setSessionHistory,
    updateSessionHistory,
    addNewSession,
  };

  return (
    <SpendAnalyticsSessionContext.Provider value={value}>
      {children}
    </SpendAnalyticsSessionContext.Provider>
  );
};
